import {
  CampaignsResourcesResponseType,
  CommunitiesResourcesResponseType,
  CoursesBundlesResourcesResponseType,
  CoursesResourcesResponseType,
  EmailsResourcesResponseType,
  SpecificEmailsResourcesResponseType,
  TagsResourcesResponseType,
  getCampaignsResources,
  getCommunitiesResources,
  getCourseBundlesResources,
  getCoursesResources,
  getEmailsResources,
  getSpecificEmailsResources,
  getTagsResources,
} from 'src/editor/api/resources-api'
import { BaseQueryWithValidationClass } from './utils/query-with-validation-class'

class TagsResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  TagsResourcesResponseType
> {
  queryFn = () => getTagsResources()
  getQueryKey = () => ['tagsResources'] as const
}

export const tagsResourcesQuery = new TagsResourcesQueryClass()

class CampaignsResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  CampaignsResourcesResponseType
> {
  queryFn = () => getCampaignsResources()
  getQueryKey = () => ['campaignsResources'] as const
}

export const campaignsResourcesQuery = new CampaignsResourcesQueryClass()

class EmailsResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  EmailsResourcesResponseType
> {
  queryFn = () => getEmailsResources()
  getQueryKey = () => ['emailsResources'] as const
}

export const emailsResourcesQuery = new EmailsResourcesQueryClass()

class SpecificEmailsResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  SpecificEmailsResourcesResponseType
> {
  queryFn = () => getSpecificEmailsResources()
  getQueryKey = () => ['specificEmailsResources'] as const
}

export const specificEmailsResourcesQuery =
  new SpecificEmailsResourcesQueryClass()

class CoursesResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  CoursesResourcesResponseType
> {
  queryFn = () => getCoursesResources()
  getQueryKey = () => ['coursesResources'] as const
}

export const coursesResourcesQuery = new CoursesResourcesQueryClass()

class CourseBundlesResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  CoursesBundlesResourcesResponseType
> {
  queryFn = () => getCourseBundlesResources()
  getQueryKey = () => ['courseBundlesResources'] as const
}

export const courseBundlesResourcesQuery =
  new CourseBundlesResourcesQueryClass()

class CommunitiesResourcesQueryClass extends BaseQueryWithValidationClass<
  [],
  CommunitiesResourcesResponseType
> {
  queryFn = () => getCommunitiesResources()
  getQueryKey = () => ['communitiesResources'] as const
}

export const communitiesResourcesQuery = new CommunitiesResourcesQueryClass()
